<template>
    <div class="TTL-el-form-search-regular">
        <el-form inline="true">
            <el-form-item>
            <wctime :option="{placeholder:'请选择推广时间',format:'YYYY-MM-DD',width:'220px',ischange:true,type:'date'}"
                :value="param.time"
                @finish="(val)=> {
                    if(val.type=='change') {
                        param.time=val.value;
                    }
                }"
            />
            </el-form-item>
            <el-form-item>
            <wcinput :option="{placeholder:'请输入教程名称',clearable:true,ischange:true,isinput:true,iskeydown:true}" 
                :value="param.key"
                @finish="(val)=> {
                    if(val.type=='input') {param.key=val.value;param.ischange=true}
                    if(val.type=='change') {param.key=val.value;param.ischange=true}
                    if(val.type=='keydown') GetList();
                }"
            />
            </el-form-item>
            <el-form-item>
            <wcbutton :option="{title:'搜索'}" @finish="GetList"/>
            </el-form-item>
            <el-form-item>
            <wcbutton :option="{title:'添加推广信息'}" @finish="$parent.JUMPVIEW({name:'EsAddPromotion'})"/>
            </el-form-item>
        </el-form>
    </div>
    
    
    <!-- 一级数据操作 -->
    <div class="TTL-table top20" :ref="objloading">
        <el-table :data="list" stripe="true" empty-text=""  @selection-change="selecttable">
            <template v-slot:empty><el-empty description="暂无数据" /></template>
            <el-table-column type="selection" />
            <el-table-column label="封面" align="center">
                <template #default="scope">
                    <wcimage :option="{size:'middle'}" :value="scope.row.avar" />
                </template>
            </el-table-column>
            <el-table-column prop="name" label="名称" align="center"/>
            <el-table-column prop="note" label="推广文案" align="center"/>
            <el-table-column prop="pro_time" label="推广时间" align="center"/>
            <el-table-column label="操作" align="center">
                <template #default="scope">
                <div class="TTL-btn-info">
                <wcbutton :option="{title:'编辑'}" @finish="EditPromotion(scope.row.id)"/>
                <wcbutton :option="{title:'删除',type:'del'}" @finish="DelPromotion(scope.row.id)" class="left10"/>
                </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
    
    
        <div class="TTL-page-box top20">
            <div class="TTL-page-box-in">
                <div class="TTL-select TTL-page-left">
                    <wcselect :option="{placeholder:'请选择操作',ischange:true,isconfim:true}" 
                        :value="handlevalue"
                        :list="handleinfos"
                        @finish="(val)=> {
                            changehandle(val.value)
                        }"
                    />
                </div>
                <div class="TTL-page TTL-page-right">
                    <wcpage :row="param.rows" :p="param.p" :rollpage="param.rollpage"
                        @finish="(val)=> {
                            param.p=val.p;
                            param.rollpage=val.rollpage;
                            GetList();
                        }"
                    />
                </div>
            </div>
        </div>
    
    
    
    
    </template>
    
    <script>
    import INTERFACE_MODEL_PROMOTION from '@/Interface/Es/promotion';
    export default {
    
        components:{
            
        },
    
        data() {
            return {
                objloading:'promotion',
                param: {
                    time:'',
                    pro_type:'',
                    key:'',
                    p:1,
                    rollpage:10,
                    ischange:false,
                    rows:0,
                },
                list:[],
                typelist:[],
                handlevalue:'',
                handleinfos:[
                    {id:1,name:'批量删除数据'},
                    {id:2,name:'批量修改数据'},
                ],
            }
        },
    
        mounted() {
    
            this.OnloadMethod(false); //页数初始化
    
        },
    
        methods: {
    
    
            /** 页数初始化 **/
            OnloadMethod(isfresh) {
                this.GetTypeList(isfresh); //获取分类信息
                this.GetList();
            },
    
    
            /** 其它组件调用当前组件进行数据传递 **/
            BrotherComponentIn(data) {
                if(data.isask) { //组件已存在，同级兄弟元素调用时产生的操作
                    this.GetList();
                }else if(data.reload) { //浏览器重新刷新时执行的操作
                    
                }else {
                    this.GetList();
                }
            },
    
    
            /** 列表数据搜索 **/
            GetList() {
                if(this.param.ischange) {
                    this.param.ischange=false;
                    this.param.p=1;
                    this.param.rollpage=10;
                }
    
                var obj=this.$refs[this.objloading];
                this.$loading.openloading(obj);
                INTERFACE_MODEL_PROMOTION.GET_PROMOTION_LIST(this.param).then((res) => {
                     this.$loading.closeloading(obj);
                     if(res.status > 0) return false;
                     this.param.rows=res.data.count;
                     this.list=res.data.list;
                });
            },
    
    
            /** 表格数据选择 **/
            selecttable(val) {
                for(var i=0;i < this.list.length;i++) this.list[i].isshow=false;
                for(var i=0;i < val.length;i++) val[i].isshow=true;
                console.log(val);
            },
    
    
            /** 删除分类信息 **/
            DelPromotion(id) {
                this.DelPromotionData(id);
            },
    
    
            /** 编辑分类信息 **/
            EditPromotion(ids) {
                this.$parent.JUMPVIEW({name:'EsEditPromotion',param:{ids:ids}});
            },
    
    
            /** 删除文件信息操作 **/
            DelPromotionData(ids) {
                INTERFACE_MODEL_PROMOTION.DEL_PROMOTION({ids:ids}).then((res) => {
                     if(res.status > 0) return false;
                     this.param.ischange=true;
                     this.GetList();
                });
            },  
    
    
            /** 批量操作 **/
            changehandle(index) {
                var ids=this.GetSelectDataIds(); //获取当前选中的id
                if(ids.length==0) {this.$notice({title:'消息提示',message:'请选择要批量执行的数据',type:'warning'});return false;}
                ids=ids.join(',');
                if(index==1) this.DelPromotionData(ids);    //批量删除
                if(index==2) this.EditPromotion(ids);   //批量修改
            },
    
    
            /** 获取被勾选中的列表数据 **/
            GetSelectDataIds() {
                var ids=[];
                ids=this.list.map((obj)=> obj.isshow ? obj.id : '');
                ids=ids.filter(element=> element!==null && element!==''); //数据进行去除空值处理
                return ids ? ids : [];
            },
    
    
            /** 获取分类信息 **/
            GetTypeList(isfresh) {
                this.$method.GET_PROMOTION_TYPE(isfresh).then((res) => {this.typelist=res;console.log(res)});
            },
    
    
        },
    }
    </script>
    <style scoped>
    ::v-deep(.TTL-switch .el-switch__label *) {font-size:13px;color:#666666;letter-spacing: 1px;}
    .TTL-btn-info {display:inline-flex;}
    </style>